import { gameTitle, formatDate } from '../../lib/format';

export const ON_OFF_COURTS = [
  {
    court: 'on',
    name: 'On',
    stats: ['offense', 'defense', 'net', 'possessions', 'pace'],
  },
  {
    court: 'off',
    name: 'Off',
    stats: ['offense', 'defense', 'net', 'possessions', 'pace'],
  },
  {
    court: 'net',
    name: 'Differential',
    stats: ['offense', 'defense', 'net', 'pace'],
    inverse: ['defense'],
  },
];

export const ON_OFF_STATS = [
  { stat: 'offense', name: 'OFF.', tooltip: 'Offense', highlight: false },
  { stat: 'defense', name: 'DEF.', tooltip: 'Defense', highlight: false },
  { stat: 'net', name: 'NET', tooltip: 'Net Difference', highlight: false },
  { stat: 'pace', name: 'PACE', tooltip: 'Pace', highlight: false },
  {
    stat: 'possessions',
    name: 'POSS.',
    tooltip: 'Possessions',
    highlight: true,
  },
];

export function getOnOffReport(metrics, gameList) {
  const players = getPlayers(metrics || []);
  const games = getGames(gameList || []);

  return {
    players,
    games,
  };
}

function getPlayers(metrics) {
  return metrics.map(metric => ({
    id: metric.player.id,
    name: metric.player.name,
    normalized: metric.player.normalized,
    jersey: metric.player.jersey,
    on: metric.on,
    off: metric.off,
    net: metric.net,
    pace: metric.pace,
  }));
}

function getGames(games) {
  return games.map(game => ({
    id: game.id,
    name: `${gameTitle(game)} (${formatDate(game.start_time)})`,
  }));
}
